export const SCHEDULED_POST_DATE_RENDER_PORTAL_ID =
  "scheduled-post-date-render-portal";
